import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import {
  Accordion,
  Headline,
  Loading,
  SectionContent,
  Text,
} from "../../../../components";
import { useGruposEncerradosConsorcios } from "../../../../hooks";
import { applyKey } from "../../../../utils";
import AccordionContent, {
  ContainerGrupo,
} from "./RelacaoGruposEncerrados.Style";

const ResultadoGruposEncerrados = ({ error, grupos }) => (
  <>
    {error ? (
      <Text textSize="sm">Não foi possível carregar a lista</Text>
    ) : null}
    {!error && grupos.length <= 0 ? (
      <Text textSize="sm">Não a grupos encerrados para essa categoria</Text>
    ) : null}
    <ContainerGrupo>
      {applyKey(grupos, ({ grupo }) => (
        <Text elementType="span" textSize="sm" text={grupo} />
      ))}
    </ContainerGrupo>
  </>
);

ResultadoGruposEncerrados.defaultProps = {
  grupos: [],
  error: null,
};
ResultadoGruposEncerrados.propTypes = {
  grupos: PropTypes.arrayOf(
    PropTypes.shape({
      grupo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ),
  error: PropTypes.oneOfType([PropTypes.object]),
};

const RelacaoGruposEncerrados = () => {
  const {
    recuperarGruposEncerrados,
    loading,
    error,
    gruposEncerradosImob,
    gruposEncerradosVeic,
  } = useGruposEncerradosConsorcios();

  const gruposEncerradosAccordion = useMemo(
    () => [
      {
        title: "Consórcio Imobiliário",
        body: (
          <ResultadoGruposEncerrados
            grupos={gruposEncerradosImob}
            error={error}
          />
        ),
      },
      {
        title: "Consórcio de Veículos",
        body: (
          <ResultadoGruposEncerrados
            grupos={gruposEncerradosVeic}
            error={error}
          />
        ),
      },
    ],
    [error, gruposEncerradosImob, gruposEncerradosVeic]
  );

  useEffect(() => {
    recuperarGruposEncerrados();
  }, [recuperarGruposEncerrados]);

  return (
    <Loading loading={loading}>
      <SectionContent>
        <Headline nivel="2" styleAs="5">
          Relação de grupos encerrados
        </Headline>
        <Text textSize="lg">
          Ao final do prazo, seu grupo será encerrado. Confira abaixo a relação
          dos grupos de acordo com o seu consórcio.
        </Text>
        <AccordionContent>
          <Accordion listItems={gruposEncerradosAccordion} />
        </AccordionContent>
      </SectionContent>
    </Loading>
  );
};

export default RelacaoGruposEncerrados;
